'use strict';

var slicedToArray = require('../../node_modules/@babel/runtime/helpers/slicedToArray.js');
var React = require('react');
require('prop-types');
var moment = require('moment');
var Paper = require('../../DesignSystem/Surfaces/Paper/Paper.js');
var EditableInput = require('../FormElements/EditableInput.js');
var DayPicker = require('../../core/Calendar/DayPicker.js');
var withStyles = require('../../node_modules/@material-ui/core/esm/styles/withStyles.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var moment__default = /*#__PURE__*/_interopDefaultLegacy(moment);

var ENTER_KEY = 13;
var DATE_FORMAT_CALENDAR = "ddd, MMM D YYYY";

var styles = function styles() {
  return {
    container: {
      flexGrow: 1,
      position: 'relative'
    },
    paper: {
      position: 'absolute',
      zIndex: 1,
      marginTop: 0,
      left: 0,
      right: 0,
      height: 263,
      width: 263,
      overflow: 'hidden'
    },
    denseInput: {
      padding: '0px 12px'
    },
    menuItem: {
      padding: '5px 12px'
    },
    inputBackground: {
      backgroundColor: '#fce8e6'
    }
  };
};

var getMoment = function getMoment(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  if (!dateFormat) {
    return moment__default["default"](date, moment__default["default"].ISO_8601);
  }

  return moment__default["default"](date, moment__default["default"].ISO_8601).format();
};

var SingleDatePicker = function SingleDatePicker(_ref) {
  var classes = _ref.classes,
      onChange = _ref.onChange,
      date = _ref.date,
      dateError = _ref.dateError;

  var _useState = React.useState(false),
      _useState2 = slicedToArray(_useState, 2),
      timeDropdownOpen = _useState2[0],
      setTimeDropdownOpen = _useState2[1];

  var _useState3 = React.useState(date),
      _useState4 = slicedToArray(_useState3, 2),
      inputDate = _useState4[0],
      setInputDate = _useState4[1];

  var _useState5 = React.useState(date),
      _useState6 = slicedToArray(_useState5, 2),
      calendarInput = _useState6[0],
      setCalendarInput = _useState6[1];

  React.useEffect(function () {
    setInputDate(updateTime(getMoment(date, true)));
  }, [date]);
  React.useEffect(function () {
    if (isValidDate(inputDate)) {
      onChange(inputDate);
    }

    setCalendarInput(getMoment(inputDate).format(DATE_FORMAT_CALENDAR));
  }, [inputDate]);

  var closeDropdown = function closeDropdown() {
    setTimeout(function () {
      setTimeDropdownOpen(false);
    }, 100);
  };

  var updateDate = function updateDate() {
    var newCalendarInput = moment__default["default"](calendarInput).toDate();

    if (isValidDate(newCalendarInput)) {
      var newInputDate = updateTime(getMoment(newCalendarInput, true));
      setInputDate(newInputDate);
    } else {
      var defaultDate = date ? date : moment__default["default"]().format();
      setCalendarInput(getMoment(defaultDate).format(DATE_FORMAT_CALENDAR));
      setInputDate(defaultDate);
    }
  };

  var handleCalendarChange = function handleCalendarChange(calendarDate) {
    var newDate = updateTime(calendarDate);
    setInputDate(newDate);
    closeDropdown();
  };

  var updateTime = function updateTime(calendarDate) {
    var defaultMoment = date ? getMoment(date) : moment__default["default"]();
    var remainder = 30 - defaultMoment.minute() % 30;
    var dateTime = remainder % 30 !== 0 ? getMoment(defaultMoment).add(remainder, "minutes") : getMoment(defaultMoment);
    var newDate = getMoment(calendarDate).hour(dateTime.hour()).minute(dateTime.minute());
    return getMoment(newDate, true);
  };

  var isValidDate = function isValidDate(validateDate) {
    return getMoment(validateDate).isValid();
  };

  var validDateForCalendar = function validDateForCalendar() {
    return isValidDate(inputDate) ? getMoment(inputDate).toDate() : date ? getMoment(date).toDate() : moment__default["default"]().toDate();
  };

  var onKeyDown = function onKeyDown(event) {
    switch (event.keyCode) {
      case ENTER_KEY:
        event.preventDefault();
        var inputEl = document.getElementById("input-date");
        inputEl.blur();
        updateDate();
        closeDropdown();
        break;
    }
  };

  var getCalendarInput = function getCalendarInput() {
    return calendarInput === 'Invalid date' ? '' : calendarInput;
  };

  return React__default["default"].createElement("div", {
    className: classes.container
  }, React__default["default"].createElement(EditableInput, {
    id: "input-date",
    autoComplete: "off",
    margin: "none",
    variant: "standard",
    onKeyDown: onKeyDown,
    onClick: function onClick() {
      setTimeDropdownOpen(true);
    },
    onChange: function onChange(event) {
      closeDropdown();
      setCalendarInput(event.target.value);
    },
    InputProps: {
      classes: {
        root: classes.denseInput
      },
      className: dateError ? classes.inputBackground : '',
      disableUnderline: true,
      value: getCalendarInput()
    }
  }), timeDropdownOpen && React__default["default"].createElement(Paper, {
    className: classes.paper
  }, React__default["default"].createElement(DayPicker, {
    selectedDay: validDateForCalendar(),
    onDayChange: function onDayChange(day) {
      return handleCalendarChange(day);
    }
  })));
};

SingleDatePicker.defaultProps = {
  dateError: false
};
var SingleDatePicker$1 = withStyles(styles)(SingleDatePicker);

module.exports = SingleDatePicker$1;
